
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","stroke-width":"1.5","stroke":"#363636","fill":"#24A4EC"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"mega"}},[_c('path',{attrs:{"d":"M28.75 26.46l4.1 4.98a3.39 3.39 0 11-5.24 4.3L22.8 29.9M31.72 24.74l-10.41 6.02a5.15 5.15 0 01-5.15-8.93l10.41-6.01M26.57 15.82l4.07-8.23a1.72 1.72 0 013.03-.1l8.81 15.27a1.72 1.72 0 01-1.6 2.57l-9.16-.59"}}),_c('path',{attrs:{"fill":"none","d":"M31.72 24.74l-5.15-8.93"}})]),_c('use',{attrs:{"href":"#mega","fill":"#F9B621","transform":"matrix(-1 0 0 1 44 0)"}})])
          )
        }
      }
    